<script>
export default {
  methods: {
    $toastNotification(variant = "success", title, message = "") {
      if (!title) {
        if (variant === 'success') {
          title = this.$t('generic.success', 'Success!');
        } else if (variant === 'danger') {
          title = this.$t('generic.error', 'Error!');
        }
      }

      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        toaster: 'b-toaster-bottom-right',
        solid: true
      });
    },

    $toastSomethingWentWrong() {
      this.$bvToast.toast(this.$t('generic.something-went-wrong', 'Something went wrong'), {
        title: this.$t('generic.error', 'Error!'),
        variant: 'danger',
        toaster: 'b-toaster-bottom-right',
        solid: true
      });
    }
  }
}
</script>